import React, { useState } from 'react';
import axios from '../../common/axios';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import '../../style.bundle.css';
import '../../plugins.bundle.css';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem } from '@mui/material';
import { useRecoilState } from 'recoil';
import { languageState } from '../../atom/loginState'

export default function SignIn() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useRecoilState(languageState);



  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`/login`, { username, password }, { withCredentials: true });

      if (response.data.success) {
        Swal.fire({
          title: t('signIn.loginSuccess'),
          text: response.data.message,
          icon: 'success',
          confirmButtonText: t('signIn.ok')
        }).then(() => {
          navigate("/home");
        });
      } else {
        Swal.fire({
          title: t('signIn.problemOccurred'),
          text: response.data.message,
          icon: 'error',
          confirmButtonText: t('signIn.ok')
        });
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || t('signIn.loginProblem');

      if (err.response?.data?.passwordExpired) {
        Swal.fire({
          title: t('signIn.passwordExpired'),
          text: t('signIn.resetPassword'),
          icon: 'warning',
          confirmButtonText: t('signIn.resetPasswordButton')
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/reset-password');
          }
        });
      } else {
        Swal.fire({
          title: t('signIn.error'),
          text: errorMessage,
          icon: 'error',
          confirmButtonText: t('signIn.ok')
        });
      }
    }
  };

  return (
    <>
      <div style={{ backgroundImage: 'url(/images/bg3-dark.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }} data-bs-theme="light">
        <div className="d-flex flex-column flex-root" style={{ minHeight: "100vh" }}>
          <div className="d-flex flex-column flex-column-fluid flex-lg-row">
            <div className="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
              <div className="d-flex flex-center flex-lg-start flex-column">
                <a href="https://www.eng.nipponsteel.com/" className="mb-7">
                  <img alt="Logo" src='/images/logo_w.svg' style={{ width: 250 }} />
                </a>
                <h2 className="text-white fw-normal m-0">NIPPON STEEL ENGINEERING Partners Portal</h2>
              </div>
            </div>
            <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12 p-lg-20">
              <div className="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-600px p-20">
                <div className="d-flex flex-center flex-column flex-column-fluid px-lg-10 pb-15 pb-lg-20">
                  <form className="form w-100" onSubmit={handleSubmit}>
                    <div className="text-center mb-11">
                      <h1 className="text-dark fw-bolder mb-3">{t('signIn.login')}</h1>
                      <div className="text-gray-500 fw-semibold fs-6">NIPPON STEEL ENGINEERING</div>
                    </div>


                    <div className="fv-row mb-8">
                      <input type="text" name="username" placeholder={t('signIn.username')} onChange={e => setUsername(e.target.value)} autoComplete="off" className="form-control bg-transparent" />
                    </div>
                    <div className="fv-row mb-3">
                      <input type="password" placeholder={t('signIn.password')} name="password" autoComplete="off" className="form-control bg-transparent" onChange={e => setPassword(e.target.value)} />
                    </div>
                    <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                      <div></div>
                      <RouterLink className="link-primary" to="/reset-password">{t('signIn.forgotPassword')}</RouterLink>
                    </div>
                    <div className="d-grid mb-10">
                      <button type="submit" className="btn btn-primary">
                        <span className="indicator-label">{t('signIn.loginButton')}</span>
                        <span className="indicator-progress">{t('signIn.pleaseWait')}
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      </button>
                    </div>
                    <div className="text-gray-500 text-center fw-semibold fs-6">
                      {t('signIn.notAMember')}
                      <RouterLink className="link-primary" to="/register">{t('signIn.signUp')}</RouterLink>
                    </div>
                  </form>



                </div>

                <div className="text-center text-gray-500 fw-semibold fs-7 mb-8">


         
                        <span
                          className={`cursor-pointer me-2 ${i18n.language === 'en' ? 'fw-bold' : ''}`}
                          onClick={() => changeLanguage('en')}
                        >
                          English
                        </span>
                        <span className="me-2">|</span>
                        <span
                          className={`cursor-pointer ${i18n.language === 'jp' ? 'fw-bold' : ''}`}
                          onClick={() => changeLanguage('jp')}
                        >
                          日本語
                        </span>
                      </div>

          


                <div className="text-center text-gray-500 fw-semibold fs-7 mt-4">
                  Version: {process.env.REACT_APP_VERSION}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}